import { render, staticRenderFns } from "./SubCategoryTabs.vue?vue&type=template&id=72d0b154&scoped=true"
import script from "./SubCategoryTabs.vue?vue&type=script&lang=js"
export * from "./SubCategoryTabs.vue?vue&type=script&lang=js"
import style0 from "./SubCategoryTabs.vue?vue&type=style&index=0&id=72d0b154&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d0b154",
  null
  
)

export default component.exports